import { makeStyles } from '@material-ui/styles'

const MESSAGE_MAX_LENGTH = 1000
const MULTILINE_LINE_HEIGHT = 1.6

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  charCount: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: '#6B7C87',
    margin: 0,
    whiteSpace: 'nowrap',
  },
  messageCardContent: {
    padding: theme.spacing(2, 2.5),
    '& > * + *': {
      borderTop: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.75, 2),
    },
  },
  messageField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      padding: 0,
      alignItems: 'flex-start',
      backgroundColor: 'transparent',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-inputMultiline': {
      padding: 0,
      fontSize: '0.9375rem',
      lineHeight: MULTILINE_LINE_HEIGHT,
      color: '#172024',
    },
  },
  messageFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  messageFooterIcon: {
    color: '#6B7C87',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
  },
  messageFooterText: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    margin: 0,
  },
  footerNote: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    margin: 0,
  },
}))

export { MESSAGE_MAX_LENGTH }
export default useStyles
